import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import APIURL from './config/api'
import baseUrl from './config/env'
import utils from './config/utils'
import require from './config/require'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import form from 'view-design/src/mixins/form'
Vue.use(ViewUI);
Vue.use(require);
Vue.prototype.$store = store
Vue.prototype.APIURL = APIURL //API接口
Vue.prototype.baseUrl = baseUrl //请求地址
Vue.prototype.utils = utils //
Vue.config.productionTip = false

Vue.prototype.$bus = new Vue({
  method: {
    emit(event, ...args) {
      this.$emit(event, ...args);
    },
    on(event, callback) {
      this.$on(event, callback);
    },
    off(event, callback) {
      this.$off(event, callback);
    }
  }
});
router.beforeEach((to, form, next)=>{
  // if(to.meta.title){
    // document.title = to.meta.title
  // }
  ViewUI.LoadingBar.start();
  next()
})
router.afterEach(route => {
  ViewUI.LoadingBar.finish();
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
